import { render, staticRenderFns } from "./IdentificationIdin.html?vue&type=template&id=7f3fabac&scoped=true&"
import script from "./IdentificationIdin.ts?vue&type=script&lang=ts&"
export * from "./IdentificationIdin.ts?vue&type=script&lang=ts&"
import style0 from "./IdentificationIdin.scss?vue&type=style&index=0&id=7f3fabac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3fabac",
  null
  
)

export default component.exports